module.exports = __webpack_public_path__ + "img/about_team.65a2760e.png";